import React from 'react'
import styled from 'styled-components'

import { header5 } from 'styles/texts'
import { gray } from 'styles/colors'

import { Textarea } from 'components/form'

const Wrapper = styled.div`
  position: relative;
`

const Counter = styled.div`
  ${header5};
  color: ${gray};
  font-style: italic;
  position: absolute;
  bottom: 14px;
  right: 14px;
`

const Length = styled.span`
  ${props => props.danger && 'color: red'};
`

const DescriptionInput = ({ value, size = 200, ...rest }) => (
  <Wrapper>
    <Textarea value={value} {...rest} />
    <Counter>
      <Length danger={value.length > size}>{value.length}</Length>/{size}
    </Counter>
  </Wrapper>
)

export default DescriptionInput



// WEBPACK FOOTER //
// ./src/components/form/DescriptionInput.js